/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Od desne proti levi",
		"timeZoneID": "Časovni pas",
		"skin": "Slog",
		"metricsFileImportTask": "Nov uvoz iz datotek",
		"displayMode": "Privzeti pogled",
		"credentialRenewed": "Vaše poverilnice so bile obnovljene s trenutnim ID-jem uporabnika in geslom.",
		"productLocale": "Jezik izdelka",
		"toggleDisabled": "izklopljeno",
		"credentialChange": "Obnovi",
		"log_level_Debug": "Razhroščevanje",
		"confirmNewPassword": "Potrditev novega gesla",
		"unsavedViewMsg2": "Če sprememb ne shranite, bodo izgubljene.",
		"supportPortalErrorMessage": "Poskusite znova.  Če težave ne odpravite, se obrnite na skrbnika.",
		"legalText": "Licenčno gradivo - lastnina IBM Corp. © Copyright IBM Corporation in drugi 2005, %{year}. IBM, IBM-ov logotip, ibm.com in Cognos so blagovne znamke ali registrirane blagovne znamke korporacije International Business Machines Corp., registrirane v številnih jurisdikcijah po vsem svetu. Trenutni seznam IBM-ovih blagovnih znamk je na voljo na spletu na naslovu www.ibm.com/legal/copytrade.shtml. Licenca za ta program je izdana v skladu s pogoji licenčne pogodbe, ki je dodana programu. Licenčno pogodbo najdete v mapi programskega imenika ali v knjižnici, ki je identificirana kot \"License\" ali \"Non_IBM_License\", ali pa je na voljo v tiskani obliki. Pred uporabo programa pozorno preberite pogodbo. Z uporabo programa se šteje, da soglašate s pogoji pogodbe.",
		"groupsAndRoles": "Skupine in vloge",
		"metricsMaintenanceTask": "Novo vzdrževanje",
		"email": "E-pošta",
		"contextual": "Kontekstualno",
		"resetHome": "Ponastavi na privzete vrednosti",
		"ltr": "Od leve proti desni",
		"credentials": "Poverilnice",
		"logging_congfig_title": "Beleženje",
		"changePasswordTitle": "Spremenite svoje geslo",
		"format": "Oblika zapisa poročila",
		"showUnread": "Pokaži neprebrano",
		"AILearning_active": "Učenje UI je vključeno:",
		"docsErrorMessage": "Poskusite znova.  Če težave ne odpravite, se obrnite na skrbnika.",
		"toggleEnabled": "vklopljeno",
		"homeSetError": "Med nastavljanjem privzete začetne strani je prišlo do napake. Poskusite zapreti in ponovno odpreti ta pogled.",
		"passwordChange": "Spremenite geslo",
		"profile": "Profil",
		"pdfRestricted": "PDF (omejeno)",
		"drillThrough": "Definicije vrtanja počez",
		"homeSet": "Začetna stran je bila uspešno nastavljena",
		"regionalOptions": "Področne nastavitve",
		"myPreferences": "Moje preference",
		"defaultHome": "Privzeto",
		"version": "Različica",
		"controller": "Controller",
		"manage": "Upravljanje",
		"biDirectionalFeaturesEnabled": "Podpora za dvosmerne jezike",
		"newFeaturesErrorTitle": "Povezava na nove funkcije ni delovala",
		"passwordMatch": "Ujemanje gesel",
		"updateProfileAndsettings": "Posodobi profil in nastavitve",
		"dashboardConsole": "Delovni prostor",
		"legacyAppsSlideoutLabel": "Razpoložljive aplikacije starejših različic",
		"logging_config_description": "Beleženje se uporablja za odpravljanje težav. Za pomoč pri nastavitvah se obrnite na skrbnika.",
		"confirmDeletion": "Potrdi izbris",
		"signInButtonText": "Prijava",
		"dataSourceCredentials": "Poverilnice podatkovnega strežnika",
		"AILearningConfigurationSlideoutAllyLabel": "Konfiguracija učenja UI",
		"loadingSettings": "Nalaganje nastavitev",
		"spreadsheetMLRestricted": "Excel (omejeno)",
		"manageAILearning": "Učenje UI",
		"xlsxDataRestricted": "Podatki Excel (omejeno)",
		"advanced": "Napredne možnosti",
		"ok": "V redu",
		"changeEmail": "Sprememba",
		"showHints": "Pokaži namige",
		"general": "Splošno",
		"xlsxData": "Podatki Excel",
		"newPassword": "Novo geslo",
		"hideAll": "Skrij vse",
		"confirmPassword": "Potrditev gesla",
		"AILearning_config_description": "Izboljšajte priporočila v izdelku tako, da Cognos Analytics omogočite učenje o vaši uporabi.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Povezava do portala za podporo ni delovala",
		"log_level_Warn": "Opozorilo",
		"contentSettings": "Nastavitve vsebine",
		"setHomeButton": "Nabor",
		"myCapabilities": "Moje zmožnosti",
		"homePage": "Domača stran",
		"helpErrorMessage": "Poskusite znova.  Če težave ne odpravite, se obrnite na skrbnika.",
		"loadingProfile": "Nalaganje profila",
		"portal": "Portal",
		"metricsPackage": "Nov paket",
		"myCredentials": "Moje poverilnice",
		"credentialCreate": "Ustvari",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Gesla ni mogoče posodobiti",
		"showHiddenObjects": "Pokaži skrite vnose",
		"csv": "CSV",
		"docsErrorTitle": "Povezava do dokumentacije ni delovala",
		"log_level_Error": "Napaka",
		"wrongPassword": "Overjanja ni mogoče izvesti",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Informacije",
		"welcomeBanner": "Pozdravna pasica",
		"helpErrorTitle": "Povezava na pomoč ni delovala",
		"contentLocale": "Jezik vsebine",
		"pdf": "PDF",
		"oldPassword": "Staro geslo",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Pripomočki za ljudi s posebnimi potrebami",
		"manageLogging": "Beleženje",
		"loggingConfigurationSlideoutA11yLabel": "Konfiguracija beleženja",
		"communityErrorTitle": "Povezava na skupnost ni delovala",
		"companionApps": "Spremljevalne aplikacije",
		"setHomeLabel": "Nastavi začetno stran kot (trenutni pogled)",
		"metricsExportTask": "Nov izvoz",
		"csvRestricted": "CSV (omejeno)",
		"newFeaturesErrorMessage": "Poskusite znova.  Če težave ne odpravite, se obrnite na skrbnika.",
		"contributor": "Contributor",
		"showAll": "Pokaži vse",
		"logging_active": "Beleženje je vključeno:",
		"html": "HTML",
		"profileAndSettings": "Profil in nastavitve",
		"baseTextDirection": "Osnovna smer za besedilo",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Geslo",
		"invalidEmail": "Vnesite veljaven e-poštni naslov",
		"credentialCreateSuccess": "Uspešno ste ustvarili svoje poverilnice.",
		"settings": "Nastavitve",
		"restrictedFormatSelected": "Nimate zmožnosti izvajati poročil v tej obliki zapisa, vendar pa lahko dostopate do poročil, ki so shranjena v tej obliki zapisa.",
		"usageDataDeletionConfirmation": "Če izbrišete podatke o uporabi, se vse učenje UI ponastavi.  Ali ste prepričani, da želite izbrisati podatke o uporabi?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Ogled podrobnosti",
		"deleteUsageData": "Izbriši podatke o uporabi:",
		"showPassword": "Pokaži geslo",
		"AILearning_config_title": "Učenje UI",
		"myPreferencesSlideoutLabel": "Profil in nastavitve",
		"passWordChangeSuccess": "Uspešno ste spremenili geslo",
		"logging_level": "Raven beleženja:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Poskusite znova.  Če težave ne odpravite, se obrnite na skrbnika.",
		"cancel": "Prekliči",
		"shareSetError": "Tega dejanja ni mogoče izvesti, dokler ne zaprete in ponovno odprete tega pogleda.",
		"passwordNotMatch": "Ups, gesli se ne ujemata",
		"xml": "XML",
		"xmlRestricted": "XML (omejeno)",
		"openMenu": "Odpri meni",
		"closeMenu": 'Zapri meni'
});